import { Button, Paginate } from '@cokitchen/cokitchen-components';
import { AddIcon } from 'cokitchen-icons';
import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './styles.css';
import CareerCard from './partials/career-card';
import { ROUTE_KEYS } from 'utils/constants';
import { apiService } from 'services/base.service';
import { handleApiError } from 'utils/functions';
import { CareerPostingType } from 'models/career';
import { ReactComponent as EmptyState } from 'assets/icons/empty-career-state.svg';
import useDashboardContext from 'contexts/dashboard.context';
import AccessDenied from 'components/access-denied';

const FILTER_TYPES = {
  open_positions: 'open',
  drafts: 'draft',
  archived: 'archived'
};

const careerArr = [
  { value: FILTER_TYPES.open_positions, name: 'Open positions' },
  { value: FILTER_TYPES.drafts, name: 'Drafts' },
  { value: FILTER_TYPES.archived, name: 'Archived' }
];
const CareersListingPage = () => {
  const [careerPageStatus, setCareerPageStatus] = useSearchParams();
  const [careerPostings, setCareerPostings] = useState<CareerPostingType[]>([]);
  const { permissions } = useDashboardContext();
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchData = async (page?: number) => {
    setLoading(true);

    try {
      const response = await apiService.get(`careers/jobs`, {
        params: {
          page: page || 1,
          size: '10',
          status: careerPageStatus.get('status') || FILTER_TYPES.open_positions
        }
      });

      setCareerPostings(response.data.data.data);
      setPageCount(Math.ceil(Number(response.data.data.pagination.total) / 10));
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  const getSelectedPageData = async (val: { selected: number }) => {
    const pageNo = val?.selected + 1;
    await fetchData(pageNo);
  };
  const filterType = careerPageStatus.get('status') || FILTER_TYPES.open_positions;
  const canViewCareers = permissions.canViewCareers;
  useEffect(() => {
    fetchData();
  }, [filterType, pageCount]);

  if (!canViewCareers) return <AccessDenied />;
  return (
    <section>
      <div className='flex justify-between'>
        <div>
          <h1 className='text-xl font-semibold'>Careers</h1>
          <p className='text-sm text-gray-5'>Manage open positions</p>
        </div>
        <div>
          <Button
            onClick={() => navigate(ROUTE_KEYS.CREATE_POSITION)}
            variant='block'
            color='primary'
            size='small'>
            <AddIcon />
            New Position
          </Button>
        </div>
      </div>
      <div className='flex justify-between items-center gap-6 mt-7 border-b border-gray-10/40 pb-6'>
        <ul className='flex gap-6 items-end h-full'>
          {careerArr.map((status) => (
            <li
              onClick={() => setCareerPageStatus({ status: status.value.toLowerCase() })}
              key={status.value.toLowerCase()}
              className={`underline_animation_normal ${
                filterType === status.value.toLowerCase()
                  ? 'underline_animation_selected'
                  : 'underline_animation_notSelected'
              }`}>
              <button className='capitalize'>{status.name}</button>
            </li>
          ))}
        </ul>
      </div>

      {loading ? (
        <div className='flex justify-center items-center h-[30vh] font-medium'>Loading...</div>
      ) : careerPostings.length > 0 ? (
        <div className='grid grid-cols-3 2xl:grid-cols-4 gap-4 mt-8'>
          {careerPostings.map((post) => (
            <CareerCard key={post.id} careerPosting={post} refetchAllPosting={fetchData} />
          ))}
        </div>
      ) : (
        <div className='flex flex-col items-center justify-center mt-32'>
          <EmptyState />
          <h2 className='text-base text-gray-6/80 font-semibold mt-4'>No Career Posting Found</h2>
        </div>
      )}

      <div className='flex justify-center mt-8'>
        <Paginate pageCount={pageCount} onPageChange={getSelectedPageData} />
      </div>
    </section>
  );
};

export default CareersListingPage;
